import atob from './atob';

export const parseInstance = instance => {
  const [, base64data] = instance.split('.', 2);
  const data = atob(base64data);
  return JSON.parse(data);
};
